import { useToast } from '@app/hooks';
import { omrService } from '@app/services';
import { ImportExcelPayload } from '@app/services/omr-service';
import { Button, ButtonProps } from '@chakra-ui/react';
import { UploadIcon } from '@heroicons/react/outline';
import { useRef, ChangeEvent } from 'react';

import { useSetState } from 'react-use';

interface ImportExcelProps extends ButtonProps {
  path?: ImportExcelPayload['path'];
  onCompleted?: () => void;
  customFormData?: { [key: string]: any };
}

export const ImportExcel = ({ path, onCompleted, customFormData, ...props }: ImportExcelProps) => {
  const [state, setState] = useSetState({ loading: false });
  const toast = useToast();

  // const id = useMemo(() => `import-excel-${Math.random()}`, []);
  const ref = useRef<HTMLInputElement>(null);

  const handleChange = async (e: ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    setState({ loading: true });

    try {
      const formData = new FormData();
      formData.append('file_excel', e.target.files[0], e.target.files[0].name);
      Object.entries(customFormData || {}).forEach(([x, y]) => {
        formData.append(x, y);
      });

      await omrService.importExcel({ path, file: formData });

      setState({ loading: false });
      toast({ title: 'Import Excel Sukses', status: 'success' });
    } catch (error) {
      setState({ loading: false });
      toast({ title: 'Import Excel Gagal', status: 'error' });
    }

    if (onCompleted) onCompleted();
  };

  return (
    <>
      <input hidden className="hidden" type="file" accept=".xls, .xlsx" ref={ref} onChange={handleChange} />
      <Button
        colorScheme="blue"
        fontWeight="light"
        leftIcon={<UploadIcon className="w-4" />}
        isLoading={state.loading}
        onClick={() => ref.current?.click && ref.current?.click()}
        {...props}
      >
        Import Excel
      </Button>
    </>
  );
};
